// @flow
import { oaManagerActions } from './oaManagerActionCreator';

const filterTableData = (newState, searchStr) => {
  const searchString = searchStr.toLowerCase().trim();
  let filteredArr;

  if (searchString) {
    filteredArr = newState.tableData.filter(
      row =>
        (row.name && row.name.toLowerCase().indexOf(searchString) >= 0) ||
        (row.mobileNo &&
          row.mobileNo.toLowerCase().indexOf(searchString) >= 0) ||
        (row.vendorCode &&
          row.vendorCode.toLowerCase().indexOf(searchString) >= 0) ||
        (row.vendorName &&
          row.vendorName.toLowerCase().indexOf(searchString) >= 0) ||
        (row.toli && row.toli.toLowerCase().indexOf(searchString) >= 0)
    );
  } else {
    filteredArr = newState.tableData;
  }

  return filteredArr;
};

const initialState = {
  isLoading: false,
  isLoaded: false,
  tableData: [],
  tableDataFiltered: []
};

const oaManagerReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case oaManagerActions.GET_ALL_DATA: {
      return { ...state, ...action.payload };
    }
    case oaManagerActions.FILTER_TABLE_DATA: {
      const newState = { ...state };
      const filteredData = filterTableData(newState, action.payload);
      return { ...state, tableDataFiltered: filteredData };
    }
    default: {
      return state;
    }
  }
};

export default oaManagerReducer;
